// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import {
  createSlice,
  type SerializedError,
  type PayloadAction,
} from '@reduxjs/toolkit';
import { type AuthUser } from '@shared/data-access/interfaces/redux';
import { authApi } from '@shared/data-access/api/auth0/auth-api';
import { initialState } from './auth-state';

export const authSlice = createSlice({
  name: 'auth',
  initialState: () => initialState,
  reducers: {
    reset: () => initialState,
    logout: () => initialState,
    setLoginError: (state, action: PayloadAction<SerializedError>) => {
      state.loginError = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(
        authApi.endpoints.exchangeCode.matchFulfilled,
        (state, { payload }) => {
          state.token = payload.access_token;
          state.refreshToken = payload.refresh_token ?? state.refreshToken;
          state.expiration_date = Date.now() + payload.expires_in * 1000;
          state.loginError = null;
        },
      )
      .addMatcher(
        authApi.endpoints.exchangeCode.matchRejected,
        (state, { error, payload }) => {
          state.loginError = (payload ?? error) as SerializedError;
        },
      )
      .addMatcher(
        authApi.endpoints.refreshTokens.matchFulfilled,
        (state, { payload }) => {
          state.token = payload.access_token;
          state.refreshToken = payload.refresh_token ?? state.refreshToken;
          state.expiration_date = Date.now() + payload.expires_in * 1000;
        },
      )
      .addMatcher(
        authApi.endpoints.getUserInfo.matchFulfilled,
        (state, { payload }) => {
          state.user = payload as AuthUser;
        },
      );
  },
});
